import React from 'react';
import { Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import moment from 'moment';

const ExportWithMonthSelect = ({ month, handleMonthChange, handleExport }) => {
  return (
    <div>
      <Button variant="contained" color="success" onClick={handleExport} style={{ marginRight: '10px', height: '55px'}}>
        Export
      </Button>
      <FormControl style={{ marginBottom: '20px' }}>
        <InputLabel id="month-select-label">Month</InputLabel>
        <Select
          labelId="month-select-label"
          id="month-select"
          value={month}
          onChange={handleMonthChange}
        >
          {Array.from({ length: 12 }, (_, i) => moment().subtract(i, 'months')).map((m) => (
            <MenuItem key={m.format('YYYY-MM')} value={m.format('YYYY-MM')}>
              {m.format('MMMM YYYY')}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default ExportWithMonthSelect;
